import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const serverFnRpcGuard = createMiddleware().server(async ({ handlerType, request, next }) => {
  if (handlerType === "serverFn" && request.headers.get("x-tsr-serverfn") !== "true") {
    return new Response("Bad server function request", { status: 400 });
  }

  return next();
});

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [serverFnRpcGuard, errorMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));
